AGADash.Tiles = (function () {
    var colors = [];
    var handlerOk = false;

    function getColorTile(record) {
        var color = colors[0];
        colors.splice(0, 1);
        colors.push(color);

        if (record["COLOR"])
            color = record["COLOR"];
        if (record["COR"])
            color = record["COR"];

        return color;
    };

    function getFontIconTile(record) {
        return record["FA"] ? record["FA"] : "";
    };

    function getTile(record, data, index) {
        var factName = data.Facts[0];
        var value = AGADash.Common.Formatter.formatByInfo(AGADash.Common.getFormatInfo(data, factName), record[factName]);

        var tileMetaData = {
            Name: record[data.Dimensions[0]],
            Value: value,
            CssClass: getColorTile(record),
            FontIcon: getFontIconTile(record)
        }

        var tile = AGA.Tile.render(tileMetaData);

        var ignoreFields = [data.Facts[0], data.Dimensions[0], "COLOR", "COR", "FA"];
        var detailKey = AGADash.Common.getDetailKey(data, index, ignoreFields);
        $(tile).find(".aga-tile").attr("data-detailkey", detailKey);

        return tile;
    };


    var showDetails = function (e) {
        var stat = e.target;
        if (!$(stat).hasClass("dashboard-stat"))
            stat = $(stat).closest(".dashboard-stat");

        var detailKey = $(stat).attr("data-detailkey");
        if (detailKey)
            AGADash.Panel.loadDetails(stat, detailKey);
    };

    var render = function (body, data) {
        $(body).addClass("dash-tiles-placeholder");

        colors = ["blue", "red", "green"];

        var fadeTime = 1000 / data.Values.length;
        if (fadeTime > 500)
            fadeTime = 500;

        var callback = function (data, body, i) {
            if (i >= data.Values.length) {
                return;
            }
            var record = AGADash.Common.getRecord(data, i);
            var tile = getTile(record, data, i);
            $(tile).hide().appendTo(body).fadeIn(fadeTime, function () { callback(data, body, i + 1); });
        }

        var row = document.createElement("div");
        row.className = "row";
        $(body).prepend(row);

        callback(data, row, 0);

        if (!handlerOk) {
            $(document).on("click", ".dashboard-stat", showDetails);
            handlerOk = true;
        }
    };

    return {
        render: render
    };
})();

AGADash.Repository.register(301, AGADash.Tiles);